<template lang="pug">
  div
</template>

<script>
export default {
  name: 'home'
}
</script>
